import React, { useEffect, useState } from 'react';
import '../css/Faq.css';

const Faq = ({ user }) => {
    const [questions, setQuestions] = useState([]);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [formData, setFormData] = useState({ title: '', text: '', anonymous: false });

    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({ title: '', question: '' });

    // Используем переменную окружения. Если её нет, используем старую ссылку как запасную
    const BASE_URL = process.env.REACT_APP_API_URL || 'https://church.info-roman-b.workers.dev';
    const API_URL = `${BASE_URL}/faq`;

    const statusMap = {
        'open': 'Открыт',
        'done': 'Закрыт'
    };

    const fetchQuestions = async () => {
        try {
            const res = await fetch(API_URL);
            const data = await res.json();
            // Показываем вопросы текущего пользователя (или анонимные, если нужно)
            setQuestions(data.filter(q => q.authorId === user.id).reverse());
        } catch (error) {
            console.error("Ошибка загрузки вопросов:", error);
        }
    };

    useEffect(() => { fetchQuestions(); }, []);

    const startEdit = (q) => {
        setEditingId(q.id);
        setEditData({ title: q.title, question: q.question });
    };

    const handleSaveEdit = async (id) => {
        const res = await fetch(API_URL, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, ...editData })
        });

        if (res.ok) {
            setEditingId(null);
            fetchQuestions();
        }
    };

    const handleSubmit = async () => {
        const newQuestion = {
            id: Date.now().toString(),
            authorId: formData.anonymous ? "anonymous" : user.id,
            authorName: formData.anonymous ? "Анонимно" : `${user.name} ${user.lastname}`,
            title: formData.title,
            question: formData.text,
            date: new Date().toLocaleString(),
            status: "open"
        };
        const res = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newQuestion)
        });
        if (res.ok) {
            setIsFormOpen(false);
            setFormData({ title: '', text: '', anonymous: false });
            fetchQuestions();
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Вы уверены, что хотите удалить этот вопрос?")) return;

        const res = await fetch(API_URL, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        });

        if (res.ok) fetchQuestions();
    };
    return (
        <div className="Faq">
            <button className="ask_btn" onClick={() => setIsFormOpen(!isFormOpen)}>
                {isFormOpen ? "Закрыть" : "Задать вопрос"}
            </button>

            {/* Твоя форма создания вопроса остается такой же... */}
            {isFormOpen && (
                <div className="faq_form">
                    <div className="anon_toggle">
                        <button className={formData.anonymous ? "active" : ""}
                                onClick={() => setFormData({...formData, anonymous: true})}>Анонимно
                        </button>
                        <button className={!formData.anonymous ? "active" : ""}
                                onClick={() => setFormData({...formData, anonymous: false})}>Открыто
                        </button>
                    </div>
                    <input type="text" placeholder="Тема" value={formData.title}
                           onChange={(e) => setFormData({...formData, title: e.target.value})}/>
                    <textarea placeholder="Текст" value={formData.text}
                              onChange={(e) => setFormData({...formData, text: e.target.value})}/>
                    <button className={"faq_form_btn"} onClick={handleSubmit}>Отправить</button>
                </div>
            )}

            <div className="my_questions">
                <h3>Мои вопросы</h3>
                {questions.map(q => (
                    <div key={q.id} className="question_card">
                        <span className={`status_tag ${q.status}`}>{statusMap[q.status] || q.status}</span>

                        {editingId === q.id ? (
                            // РЕЖИМ РЕДАКТИРОВАНИЯ
                            <div className="faq_form">
                                <input
                                    value={editData.title}
                                    onChange={(e) => setEditData({...editData, title: e.target.value})}
                                />
                                <textarea
                                    value={editData.question}
                                    onChange={(e) => setEditData({...editData, question: e.target.value})}
                                />
                                <div className="anon_toggle">
                                    <button className={"anon_first_btn"}
                                            onClick={() => handleSaveEdit(q.id)}>Сохранить
                                    </button>
                                    <button onClick={() => setEditingId(null)}>Отмена</button>
                                </div>
                            </div>
                        ) : (
                            // ОБЫЧНЫЙ РЕЖИМ
                            <>
                                <h4>{q.title}</h4>
                                <p>{q.question}</p>
                                <div className="card_footer">
                                    <div className={"card_footer_date"}>{q.date}</div>
                                    <div className={"card_footer_btns"}>
                                        <button className="edit_btn" onClick={() => startEdit(q)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                                 strokeLinecap="round" strokeLinejoin="round"
                                                 className="icon icon-tabler icons-tabler-outline icon-tabler-pencil">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"/>
                                                <path d="M13.5 6.5l4 4"/>
                                            </svg>
                                        </button>
                                        <button className="delete_btn" onClick={() => handleDelete(q.id)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                 viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                                 strokeLinecap="round" strokeLinejoin="round"
                                                 className="icon icon-tabler icons-tabler-outline icon-tabler-pencil">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <path d="M4 7l16 0"/>
                                                <path d="M10 11l0 6"/>
                                                <path d="M14 11l0 6"/>
                                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"/>
                                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Faq;